/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetCustomerSalesRepResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetCustomerSalesRepResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/customers/{customerNumber}/salesrep
 */
export interface SalesrepRequestBuilder extends BaseRequestBuilder<SalesrepRequestBuilder> {
    /**
     * Get basic contact information (name, email, phone) for a Customer's Sales Rep, plus whether that rep is currently active. An inactive rep is still shown to the customer, but flows that hand work to the rep (such as sending a cart for review) are refused.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetCustomerSalesRepResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetCustomerSalesRepResponse | undefined>;
    /**
     * Get basic contact information (name, email, phone) for a Customer's Sales Rep, plus whether that rep is currently active. An inactive rep is still shown to the customer, but flows that hand work to the rep (such as sending a cart for review) are refused.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SalesrepRequestBuilderUriTemplate = "{+baseurl}/api/customers/{customerNumber}/salesrep";
/**
 * Metadata for all the requests in the request builder.
 */
export const SalesrepRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SalesrepRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetCustomerSalesRepResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
